import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Clipboard } from "lucide-react";

interface ICopyToClipboardButton {
    id: string;
    clipboard: any;
    className?: string;
    title?: string;
    onClick: () => void;
}

export const CopyToClipboardButton = ({
    id,
    clipboard,
    className,
    title = "Copy to Clipboard",
    onClick
}: ICopyToClipboardButton): React.ReactElement => {
    const target = useRef<HTMLButtonElement>(null);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

    useEffect(() => {
        if (clipboard) {
            if (window["clipboardData"] && window["clipboardData"].setData) {
                if (target.current) {
                    const rect = target.current.getBoundingClientRect();
                    setTooltipPos({ top: rect.top - 36, left: rect.left - 8 });
                }
                setTooltipOpen(true);
                setTimeout(() => setTooltipOpen(false), 2000);
                window["clipboardData"].setData("Text", clipboard);
            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                const textarea = document.createElement("textarea");
                textarea.textContent = clipboard;
                textarea.style.position = "fixed";
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    document.execCommand("copy");
                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                } finally {
                    if (target.current) {
                        const rect = target.current.getBoundingClientRect();
                        setTooltipPos({ top: rect.top - 36, left: rect.left - 8 });
                    }
                    setTooltipOpen(true);
                    setTimeout(() => setTooltipOpen(false), 2000);
                    document.body.removeChild(textarea);
                }
            }
        }
    }, [clipboard]);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <div className={"relative " + (className ? className : "")}>
            {tooltipOpen &&
                createPortal(
                    <span
                        className="text-center p-1.5"
                        style={{
                            position: "fixed",
                            top: tooltipPos.top,
                            left: tooltipPos.left,
                            backgroundColor: "#1f2937",
                            color: "#ffffff",
                            borderRadius: "6px",
                            zIndex: 9999
                        }}
                    >
                        Copied!
                    </span>,
                    document.body
                )}
            <button id={id} ref={target} type="button" className="btn btn-light btn-sm pt-0" title={title} onClick={handleClick}>
                <Clipboard className="w-4 h-4" />
            </button>
        </div>
    );
};
